import { render, staticRenderFns } from "./PreAutoScroll.vue?vue&type=template&id=ba5f9db6"
import script from "./PreAutoScroll.vue?vue&type=script&lang=js"
export * from "./PreAutoScroll.vue?vue&type=script&lang=js"
import style0 from "./PreAutoScroll.vue?vue&type=style&index=0&id=ba5f9db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports